import React, { useRef, useState } from "react";
import { Form, Formik } from "formik";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { FormButton, CircularIndeterminate } from "components";
import { SFHotelEmpleadoDel } from "services/services-mia/";

export default function UpdateModal({ empleado, updateList, closeModal }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const functions = {
        setSnackbarInfo,
        setInRequest,
        setIsOpen: closeModal,
        updateList,
    };

    const handleSubmit = async (values) => {
        setInRequest(true);
        const response = await SFHotelEmpleadoDel({
            msuAdicionalId: empleado.id,
        }, credentials);

        handleResponse(
            response,
            "Empleado eliminado exitosamente",
            functions
        );

        setInRequest(false);
    };


    return (
        <Formik
            innerRef={formikRef}
            initialValues={{}}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    await handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles.column} style={{ maxWidth: "400px", margin: "0 auto" }}>

                    <h2 style={{ textAlign: "center", margin: "0.2em 0 0.1em 0", lineHeight: "1.3", fontSize: "1.2em" }}>
                        Estás por eliminar al {empleado.rolNombre} <br />
                        <span style={{ fontSize: "1.1em", fontWeight: "bold" }}>
                            {empleado.usuarioNombres + " " + empleado.usuarioApellidos}
                        </span>
                    </h2>
                    <h3 style={{
                        textAlign: "center",
                        margin: "0",
                        fontWeight: 500,
                        color: "#000000ff",
                        fontSize: "",
                        lineHeight: "1.4"
                    }}>
                        Una vez eliminado, no podrás recuperarlo. <br /> ¿Querés continuar?
                    </h3>

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}